import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import editDropdownGif from '@/assets/images/edit-dropdown.gif';

import { dcrIntroModalContentStyles as sx } from './DcrIntroModalContent.styles';

export const DcrIntroModalContent = () => {
	const { t } = useTranslation();

	return (
		<Box sx={sx.root}>
			<Box
				component='img'
				src={editDropdownGif}
				alt={t('Hovering over a field to edit its value')}
				sx={sx.image}
			/>

			<Box sx={sx.textGroup}>
				<Typography sx={sx.primaryText}>
					{t('You can now request changes directly on the profile page.')}
				</Typography>
				<Typography sx={sx.secondaryText}>
					{t(
						'Hover over a field, make your change, and submit. No forms to fill out.'
					)}
				</Typography>
			</Box>
		</Box>
	);
};
